import React, { Component } from 'react';
import Divider from 'material-ui/Divider';
import Card, { CardActions, CardContent } from 'material-ui/Card';
import Button from 'material-ui/Button';
import {observer,inject} from 'mobx-react';
import {changeProject,gotoProject} from "../../constants/theme";
import {withRouter} from 'react-router';

import MapProject from "./mapProject";

@inject("summaryDataStore")
@inject("projectDataStore")
@observer
class ProjectDetail extends Component {
    changeProject() {
        this.props.projectDataStore.resetWizard();
        this.props.history.push("/wizard");
    }
    render() {
        const { project, plan, beginPrice, subType } = this.props.summaryDataStore;
        const bgImg = "url('"+project.backgroundUrl+"')";
        return (
            // <div className='projectDetail' style={{backgroundImage: bgImg}}>
            //     <div className=''>
            <div >
                <div className='projectDetail' style={{backgroundImage: bgImg}}>
                    <Card className='projectCard'>
                        <div style={{display:'flex',justifyContent:'space-around'}}>
                            <h1>โครงการของคุณ</h1>
                            <Button style={changeProject} onClick={() => this.changeProject()} >
                                <span>เปลี่ยนโครงการ</span>
                            </Button>
                        </div>
                        <div className='projectMap'>
                            <MapProject />
                        </div>
                        <CardContent className='cardContent'>
                            <div className='detail'>
                                <div className='center'>
                                    <img src={project.logoUrl} alt='logoProject' className='logoProject' />
                                    <div>
                                        <span className='nameProject'>{project.title}</span>
                                        <br/>
                                        <span>{project.site}</span>
                                        <br/>
                                        {
                                            subType !== 'บ้านเดี่ยว' ? null : <div><span> แบบแปลน: {plan.title}</span><br/></div>
                                        }
                                        <span>ราคาเริ่มต้น: { this.props.summaryDataStore.format_(beginPrice) } บาท</span>
                                    </div>
                                </div>
                            </div>
                        </CardContent>
                        <Divider />
                        <CardActions className='footerCard'>
                            <Button style={gotoProject} onClick={() => this.props.summaryDataStore.gotoDetailProject()} >ดูรายละเอียดโครงการ</Button>
                        </CardActions>
                    </Card>
                </div>

            </div>
        );
    }
}

export default withRouter(ProjectDetail);



// WEBPACK FOOTER //
// ./src/components/header/projectDetail.js